import React from 'react'

export const AdminTitle = ({title}) => {
  return (
    <div className="text-3xl font-medium  uppercase">
      {title}
    </div>
  )
}
